
import { mapGetters } from 'vuex'
// PRODUCTION
import btConfig from '@/tenantConfigs/BT_config.js'
import webConfig from '@/tenantConfigs/WEB_config.js'
import fcrConfig from '@/tenantConfigs/FCR_config.js'
import a1800Config from '@/tenantConfigs/A1800_config.js'
import tideConfig from '@/tenantConfigs/TIDE_config.js'

// QA
import btQAConfig from '@/tenantConfigs/QA_BT_config.js'
import webQAConfig from '@/tenantConfigs/QA_WEB_config.js'
import fcrQAConfig from '@/tenantConfigs/QA_FCR_config.js'
import a1800QAConfig from '@/tenantConfigs/QA_1800_config.js'
import tideQAConfig from '@/tenantConfigs/QA_TIDE_config.js'

const tenantConfigMixin = {
  computed: {
    ...mapGetters(['hostname'])
  },

  methods: {
    selectConfigFile () {
      switch (this.getTenantEnv()) {
        case 'TIDE_QA':
          return tideQAConfig

        case 'TIDE_PROD':
          return tideConfig

        case 'FCR_QA':
          return fcrQAConfig

        case 'FCR_PROD':
              return fcrConfig

        case '1800_QA':
            return a1800QAConfig

        case '1800_PROD':
            return a1800Config

        case 'BT_QA':
          return btQAConfig

        case 'BT_PROD':
          return btConfig

        default:
          return webConfig
      }
    },

    getTenantConfig (section, value = null) {
      var tenantConfig = this.selectConfigFile()
      if (value != null) {
        if (typeof tenantConfig.CONFIG[section] !== 'undefined' &&
            typeof tenantConfig.CONFIG[section][value] !== 'undefined') {
          return tenantConfig.CONFIG[section][value]
        }
      } else {
        if (typeof tenantConfig.CONFIG[section] !== 'undefined') {
          return tenantConfig.CONFIG[section]
        }
      }
      return false
    },

    getTenantEnv () {
      switch (this.hostname) {
        case 'fcr-stg.web.com':
        case 'fcr-stg.azurefd.net':
          return 'FCR_QA'

          break

        case 'hub.fcrmedia.be':
          return 'FCR_PROD'

          break

        case '1800accountant-stg.web.com':
          return '1800_QA'
        break

        case '1800accountant-svc.web.com':
          return '1800_PROD'
        break

        case 'bt-stg.web.com':
          return 'BT_QA'

          break

        case 'bt.web.com':
          return 'BT_PROD'

          break

        case 'tide-stg.web.com':
          return 'TIDE_QA'

          break

        case 'tide.web.com':
          return 'TIDE_PROD'

          break

        default:
          return 'WEB_PROD'
      }
    }

  }
}

export default tenantConfigMixin
